import { writable } from 'svelte/store';
import { io } from 'socket.io-client';
let socket;
const connectSocket = () => {
    socket = io('https://world-explorer-backend.herokuapp.com').connect();
    return socket;
};
const isConnected = () => {
    return socket === null || socket === void 0 ? void 0 : socket.connected;
};
const disconnectSocket = () => {
    socket === null || socket === void 0 ? void 0 : socket.disconnect();
};
const LoaderStore = writable({
    connectSocket,
    isConnected,
    disconnectSocket,
});
export default LoaderStore;
